import script from "./DashboardChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardChart.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardChart.vue?vue&type=style&index=0&id=55df521a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55df521a"]])

export default __exports__